var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-pageframe',{attrs:{"title":_vm.title}},[_c('v-container',{staticStyle:{"padding":"15px"},attrs:{"fluid":""}},[_c('m-rc-crm-organization-meta-data',{on:{"update-organization":_vm.onUpdateOrganizationMetaData}}),_c('h2',[_vm._v("Notes")]),_c('m-rc-crm-notes',{attrs:{"organization_id":_vm.$route.params.organization_id}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }